module.exports = __webpack_public_path__ + "static/media/murat.14f59741.jpg";